const BASE_COLUMNS = [
  // {
  //   title: '审核 ID',
  //   dataIndex: 'relate_id',
  //   width: 280,
  //   scopedSlots: { customRender: 'relate_id' }
  // },
  {
    title: '资源 ID',
    dataIndex: 'resource_id',
    width: 280,
    scopedSlots: { customRender: 'resource_id' }
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '分类',
    dataIndex: 'category'
  },
  {
    title: '业务方',
    dataIndex: 'source'
  },
  {
    title: '账号名称',
    dataIndex: 'account_name',
    scopedSlots: { customRender: 'account_name' }
  },
  {
    title: '内容标题',
    dataIndex: 'contentTitle',
    scopedSlots: { customRender: 'contentTitle' }
  }
]

// 内容管理 / 已通过
export const PASS_COLUMNS = [
  ...BASE_COLUMNS,
  {
    title: '状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'is_published',
    scopedSlots: { customRender: 'is_published' }
  }
]

// 内容管理 / 审核中
export const REVIEW_COLUMNS = [...BASE_COLUMNS]

// 自媒体子任务
export const weMediaSubListColumns = [
  // {
  //   title: '审核 ID',
  //   dataIndex: 'relate_id'
  // },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '业务方',
    dataIndex: 'source'
  },
  {
    title: '账号名称',
    dataIndex: 'account_name'
  },
  {
    title: '内容标题',
    dataIndex: 'title'
  },
  {
    title: '状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]
